import { useMemo } from 'react';
import { useSubcontractors } from '@hooks/api/organization/useSubcontractors';
import { Subcontractor } from '@models/organization.model';

// Sprint 25, story-134. Raw subcontractor + project list, used for the project filter
// (`useProjectOptions`) only. The sidebar's health/attention data comes from the new
// `useSubcontractorRoster` hook instead. The previous loading-flag-only
// `useTasksByOriginalOrganizationId` call is removed — nothing here ever read its data, only its
// `isLoading`, and `useSubcontractorOverview`'s own loading state now covers that.
export const useSubcontractorData = () => {
  const { data: apiSubcontractors = [], isLoading: apiLoading, error: apiError } = useSubcontractors();

  const subcontractors = useMemo((): Subcontractor[] => {
    if (apiSubcontractors.length > 0 && !apiError) {
      return apiSubcontractors;
    }
    return [];
  }, [apiSubcontractors, apiError]);

  const isLoading = apiLoading;
  const isEmpty = subcontractors.length === 0;

  return {
    subcontractors,
    isLoading,
    error: apiError,
    isEmpty,
  };
};
